<template>
  <button
    class="btn btn-default btn-xs"
    v-on:click="$emit('toggleHelp')"
  >
    Help <span v-if="!helpAreaVisible">▾</span><span v-else>▴</span>
  </button>
</template>

<script>
export default {
  name: 'toggle-help-button',
  props: ['helpAreaVisible'],
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/help/toggle-help-button.vue